import { Injectable } from '@angular/core';
import Storage from '@aws-amplify/storage';
import { from, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HandleAWSS3Error } from './error.handler';
import { S3Config } from '../config/storage.config';
import { configureAmplify } from '../config/aws.config';


@Injectable()
export class StorageService {

    constructor() {
        configureAmplify(false);
    }


    uploadFile(key: string, file: any, fileType: string): Observable<any> {
        return from(Storage.vault.put(key, file, { contentType: fileType}))
                    .pipe(catchError(err => HandleAWSS3Error(err)));
    }

    getFile(key: string, expiresInMins = 10): Observable<any> {
        return from(Storage.vault.get(key,  { expires: expiresInMins * 60 } ))
                    .pipe(catchError(err => HandleAWSS3Error(err)));

    }


}
